import map from "./map.js";
import property from "./property.js";
export default function pluck(obj, key) {
  return map(obj, property(key));
}
